<!-- <div fxLayout="row" fxLayoutAlign="space-between center">
  <h3 appMargin marginB="0" class="ui primary header">Archived Equipment</h3>

  <div>
    <button
      class="ui medium primary basic dropdown button"
      [disabled]="pending"
      style="padding: 13px 18px; border-radius: 6px; margin-right: 15px"
      suiDropdown
    >
      <div class="text">Actions</div>
      <i class="dropdown icon"></i>
      <div
        appMargin
        marginT="2"
        class="menu"
        suiDropdownMenu
        appPadding
        paddingX="3"
        style="max-width: 250px; word-break: break-word"
      >
        <a class="item" (click)="downloadTemplate()"
          >Download Equipment <br />Template</a
        >

        <a class="item" (click)="uploader.click()"
          ><input
            #uploadDoc
            type="file"
            #uploader
            accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
            (change)="uploadImage($event)"
            placeholder="Browse for documents"
            onclick="value = null"
            style="display: none"
          />Upload Equipment List</a
        >
      </div>
    </button>
  </div>
</div>
<hr />  -->
<app-advanced-search-filter
  [filter]="filter"
  (onSearch)="searchRecords($event)"
  (onDisplayRows)="displayRecords($event)"
  (onSort)="sortRecords($event)"
  [hasSort]="true"
  [hasDisplayRows]="true"
  [hasAdvancedSearch]="true"
  [hasFilters]="true"
></app-advanced-search-filter>

<div class="ui vertical basic segment" *ngIf="success || error">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div
  class="ui vertical basic segment"
  [ngClass]="{ loading: pending }"
  appMargin="0"
  appPadding="0"
>
  <div
    *ngFor="let workflow of companyEquipments"
  >
    <div
      appMargin
      marginT="5"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start center"
    >
      <div
        class="ui vertical basic segment"
        fxLayout="row"
        appMargin
        marginT="5"
        appPadding="0"
        fxLayoutAlign="start center"
        fxLayoutGap="64px"
      >
        <div
          class="parent"
          fxLayout="row"
          fxLayoutGap="12px"
          fxLayoutAlign="start center"
        >
          <div>
              <sui-checkbox> </sui-checkbox>
          </div>
          <div
            fxLayout="column"
            fxLayoutGap="12px"
          >
            <div class="row-1">
              {{ getEquipmentTypeName(workflow?.equipTypeId) }}
            </div>
            <div class="row-2">
              {{ workflow?.equipName }}
            </div>
            <div class="row-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="35px">
              <div class="content" fxFlex="100px">
                <div class="top">Model Number</div>
                <div class="bottom">
                  {{ workflow?.equipModelNumber }}
                </div>
              </div>
              <div class="content" fxFlex="120px">
                <div class="top">Year of Manufacture</div>
                <div class="bottom">
                  {{ workflow?.yearOfManufacture }}
                </div>
              </div>
              <div class="content" fxFlex="150px">
                <div class="top">Date Added</div>
                <div class="bottom">
                  {{ workflow?.dateCreated | date }}
                </div>
              </div>
              <div class="content" fxFlex="200px">
                <div class="top">Added By</div>
                <div class="bottom">
                  {{ workflow?.createdBy | createdBy }}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div fxFlex="25%" class="text-right" fxLayout="row" fxLayoutAlign="end center">
                <button
                  appMargin
                  marginX="10px"
                  *isPermitted="{ id: 'EQUIPMENT_MANAGEMENT', action: 'remove' }"
                  class="ui circular tiny button"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="delete"
                  (click)="delete(workflow)"
                >
                  <!-- <i class="trash icon"></i> -->
                  <img class="trash icon"  src="../../../../../../../assets/icons/trash1.svg" alt="trash">
                </button>
                <button
                  *isPermitted="{ id: 'EQUIPMENT_MANAGEMENT', action: 'edit' }"
                  class="ui circular tiny button"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="Restore"
                  (click)="onRestoreModal(workflow)"
                >
                  <!-- <i class="refresh icon"></i> -->
                  <img class="refresh icon"  src="../../../../../../../assets/icons/history_24px.svg" alt="refresh">
                </button>
              </div>
    </div>
    <div class="ui divider"></div>
  </div>

  <!-- <div appMargin marginT="16px">
    <app-no-record-found
      *ngIf="companyEquipments && companyEquipments.length < 1"
    ></app-no-record-found>
  </div> -->
  <div
      class="ui segment"
      appMargin
      marginT="16px"
      *ngIf="companyEquipments && companyEquipments.length < 1"
    >
      <esl-empty
          [title]="'No items yet'"
          [description]="'Click the Add Equipment button above and archive them to see them here'"
          imgType="illustration"
      ></esl-empty>
    </div>

</div>


<div class="ui vertical basic segment">
        <div class="ui two column grid">
          <div class="column middle aligned">
            <div class="ui medium labeled button">
              <div class="records-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 1C13.866 1 17 2.79086 17 5C17 7.20914 13.866 9 10 9C6.13401 9 3 7.20914 3 5C3 2.79086 6.13401 1 10 1ZM15.694 9.13079C16.1576 8.86588 16.6044 8.54736 17 8.17775V10C17 12.2091 13.866 14 10 14C6.13401 14 3 12.2091 3 10V8.17775C3.3956 8.54736 3.84244 8.86588 4.30604 9.13079C5.83803 10.0062 7.85433 10.5 10 10.5C12.1457 10.5 14.162 10.0062 15.694 9.13079ZM3 13.1777V15C3 17.2091 6.13401 19 10 19C13.866 19 17 17.2091 17 15V13.1777C16.6044 13.5474 16.1576 13.8659 15.694 14.1308C14.162 15.0062 12.1457 15.5 10 15.5C7.85433 15.5 5.83803 15.0062 4.30604 14.1308C3.84244 13.8659 3.3956 13.5474 3 13.1777Z"
                    fill="#86879D"
                  />
                </svg>
              </div>
              <a class="ui basic label records-text"
                >{{ totalItems }} Record(s)</a
              >
            </div>
          </div>
          <div
            class="column right aligned pagination menu"
            style="margin-left: auto"
          >
            <sui-pagination
              class="mini"
              [collectionSize]="totalItems"
              [pageSize]="rows"
              [maxSize]="maxSize"
              [hasEllipses]="false"
              [page]="currentPage"
              (pageChange)="nextPage($event)"
            >
            </sui-pagination>
          </div>
        </div>
      </div>
